import {HttpVerbo, xfetch} from "../util";


export default class ItemServico {
  static getItem = (id) => {
    return xfetch('/item/'+id, {}, HttpVerbo.GET)
  }
}